<template>
  <div class="products-export-create">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />

    <div class="form-card">
      <div class="section-title">任务信息</div>
      <div class="form-row">
        <div class="label required">文件名</div>
        <div>
          <div class="file-name-row">
            <a-input
              v-model:value="form.fileName"
              :maxlength="100"
              placeholder="请输入文件名"
            />
            <span class="count">{{ form.fileName.length }}/100</span>
            <span class="suffix">.csv</span>
          </div>
          <div v-if="errors.fileName" class="error-text">{{ errors.fileName }}</div>
        </div>
      </div>

      <div class="section-title">数据筛选条件</div>
      <div class="form-row">
        <div class="label required">选择站点</div>
        <div class="field-content" ref="marketplaceSelectRef">
          <artmisads-select
            style="width: 232px"
            v-model:value="form.countryCode"
            :getPopupContainer="() => marketplaceSelectRef"
            :options="COUNTRY_BASE_OPTIONS"
           
          />
        </div>
      </div>

      <div
        class="filter-row"
        v-for="(item, index) in form.filters"
        :key="`filter-${index}`"
      >
        <a-select
          v-model:value="item.field"
          :options="filterFieldOptions"
          style="width: 160px"
          @change="onFilterFieldChange(item)"
        />
        <template v-if="getFieldConfig(item.field).type === 'number'">
          <a-select
            v-model:value="item.operator"
            :options="comparisonOperators"
            style="width: 140px"
          />
          <a-input-number
            v-model:value="item.value"
            placeholder="请输入数值"
            style="width: 200px"
            :min="0"
          />
        </template>
        <template v-else-if="getFieldConfig(item.field).type === 'boolean'">
          <a-select
            v-model:value="item.value"
            :options="yesNoOptions"
            style="width: 200px"
            placeholder="请选择"
          />
        </template>
        <template v-else-if="getFieldConfig(item.field).type === 'status'">
          <a-select
            v-model:value="item.value"
            :options="statusOptions"
            style="width: 200px"
            placeholder="请选择状态"
          />
        </template>
        <template v-else-if="getFieldConfig(item.field).type === 'brand'">
          <a-select
            v-model:value="item.values"
            mode="multiple"
            show-search
            allow-clear
            :filter-option="false"
            :options="brandOptions"
            placeholder="搜索并选择品牌"
            style="width: 320px"
            @search="onBrandSearch"
          />
        </template>
        <a
          v-if="form.filters.length > 1"
          href="javascript:void(0)"
          class="remove-link"
          @click="removeFilter(index)"
        >
          移除筛选字段
        </a>
      </div>

      <div class="filter-tip">多个字段筛选条件同时存在时，取交集</div>
      <a href="javascript:void(0)" class="add-link" @click="addFilter">
        增加筛选字段
      </a>

      <div class="section-title">导出字段选择</div>
      <div class="form-row">
        <div class="label" :class="{ required: needPublisher }">选择Publisher账号</div>
        <div class="field-content">
          <!-- <a-select
            v-model:value="form.publisherId"
            :options="publisherOptions"
            style="width: 280px"
            placeholder="请选择Publisher账号"
          /> -->
          <artmisads-select
            show-search
            v-model:value="form.publisherId"
            style="width: 232px"
            :options="publisherOptions"
            @search="searchPublisher"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            placeholder="All"
            allowClear
          />
          <div class="tip">
            当需要以某个Publisher账号的数据导出时，请从封装框里选择对应publisher
          </div>
          <div v-if="errors.publisherId" class="error-text">{{ errors.publisherId }}</div>
        </div>
      </div>

      <div class="checkbox-actions">
        <a href="javascript:void(0)" @click="selectAllFields">全选</a>
        <span>/</span>
        <a href="javascript:void(0)" @click="invertFields">反选</a>
      </div>

      <a-checkbox-group v-model:value="form.exportFields">
        <div class="field-grid">
          <label class="field-item" v-for="field in exportFieldOptions" :key="field.value">
            <a-checkbox :value="field.value" :disabled="field.value === 'ASIN'">
              {{ field.label }}
            </a-checkbox>
          </label>
        </div>
      </a-checkbox-group>
      <div v-if="errors.exportFields" class="error-text">{{ errors.exportFields }}</div>

      <div class="footer-actions">
        <artmisads-button isSquare="true" @click="onCancel">取消</artmisads-button>
        <artmisads-button isSquare="true" type="primary" @click="onSubmit">
          创建任务
        </artmisads-button>
      </div>
    </div>
  </div>
</template>
<script setup>
import breadcrumbs from '../../breadcrumbs.vue'
import { publisherAdminApi } from '~/server/index'
import { computed, reactive, ref, watch } from 'vue'
import { message } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import api from '~/server/operator/api'
import { COUNTRY_BASE,CURRENCY_MAPPER } from "@/contants/common";
import { productsExportApi } from '~/server/operator/productsExport'
const router = useRouter()
const marketplaceSelectRef = ref(null)
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map(item => {
    item.value = item.countryCode;
    item.label = item.host;
    return item;
  })
const breadcrumbsData = ref({
  title: '创建导出任务',
  des: '',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Operation',
      path: '/operator/operation/productsExport',
    },
    {
      name: 'ProductsExport',
      path: '/operator/operation/productsExport',
    },
  ],
})


const publisherOptions=ref([])
const searchPublisher = async keyword => {
    const params = {
      keyword,
      marketplace: CURRENCY_MAPPER[form.countryCode].host
    };
    let data = await publisherAdminApi.searchPublisher(params);
    if (data && data.length) {
      data = data.map(item => {
        item.value = item.id;
        item.label = item.creatorName;
        return item;
      })
      publisherOptions.value = data;
    }
  }
const filterFieldOptions = [
  { label: '价格', value: 'PRICE' },
  { label: '佣金率', value: 'COMMISSION_RATE' },
  { label: '当前是否有折扣', value: 'HAS_DEAL' },
  { label: '库存', value: 'IN_STOCK' },
  { label: 'Payout', value: 'PAYOUT' },
  { label: '品牌', value: 'BRAND' },
  { label: 'Best Seller Rank', value: 'BEST_SELLER_RANK' },
  { label: 'Rating', value: 'RATING' },
  { label: '# of Ratings', value: 'NUM_RATINGS' },
  { label: '是否ACC商品', value: 'IS_ACC_PRODUCT' },
  { label: '状态', value: 'ATTRIBUTION_STATUS' },
]

const comparisonOperators = [
  { label: '大于', value: 'GT' },
  { label: '大于等于', value: 'GTE' },
  { label: '等于', value: 'EQ' },
  { label: '小于', value: 'LT' },
  { label: '小于等于', value: 'LTE' },

]

const yesNoOptions = [
  { label: '是', value: 'true' },
  { label: '否', value: 'false' },
]

const statusOptions = [
  { label: 'all', value: 'all' },
  { label: 'inactive', value: 'inactive' },
  { label: 'active', value: 'active' },
]

const fieldConfigMap = {
  PRICE: { type: 'number' },
  COMMISSION_RATE: { type: 'number' },
  HAS_DEAL: { type: 'boolean' },
  IN_STOCK: { type: 'boolean' },
  PAYOUT: { type: 'number' },
  BRAND: { type: 'brand' },
  BEST_SELLER_RANK: { type: 'number' },
  RATING: { type: 'number' },
  NUM_RATINGS: { type: 'number' },
  IS_ACC_PRODUCT: { type: 'boolean' },
  ATTRIBUTION_STATUS: { type: 'status' },
}

const brandOptions = ref([])



const exportFieldOptions = [
  { label: 'ASIN', value: 'ASIN' },
  { label: 'Product ID', value: 'PRODUCT_ID' },
  { label: 'ProductName', value: 'PRODUCT_NAME' },
  { label: 'Image URL', value: 'IMAGE_URL' },
  { label: 'Brand', value: 'BRAND' },
  { label: 'Marketplace', value: 'MARKETPLACE' },
  { label: 'Price', value: 'PRICE' },
  { label: 'Currency', value: 'CURRENCY' },
  { label: 'Commission', value: 'COMMISSION' },
  { label: 'Est.Payout', value: 'EST_PAYOUT' },
  { label: 'No. of Ratings', value: 'NO_OF_RATINGS' },
  { label: 'Category', value: 'CATEGORY' },
  { label: 'Availability', value: 'AVAILABILITY' },
  { label: 'Best Seller Rank', value: 'BEST_SELLER_RANK' },
  { label: 'Ratings', value: 'RATINGS' },
  { label: 'Deal Start', value: 'DEAL_START' },
  { label: 'Deal End', value: 'DEAL_END' },
  { label: 'Deal Price', value: 'DEAL_PRICE' },
  { label: 'Clippable Start', value: 'CLIPPABLE_START' },
  { label: 'Clippable End', value: 'CLIPPABLE_END' },
  { label: 'Clippable Price', value: 'CLIPPABLE_PRICE' },
  { label: 'PromoCode', value: 'PROMO_CODE' },
  { label: 'PromoCode Start', value: 'PROMO_CODE_START' },
  { label: 'PromoCode End', value: 'PROMO_CODE_END' },
  { label: 'PromoCode Price', value: 'PROMO_CODE_PRICE' },
  { label: 'Attribution URL', value: 'ATTRIBUTION_URL' },
]

const createDefaultFilter = () => ({
  field: 'PRICE',
  operator: 'LT',
  value: undefined,
  values: [],
})

const form = reactive({
  fileName: '',
  countryCode: 'US',
  publisherId: undefined,
  filters: [createDefaultFilter()],
  exportFields: ['ASIN'],
})
const errors = reactive({
  fileName: '',
  publisherId: '',
  exportFields: '',
})

const needPublisher = computed(() => form.exportFields.includes('ATTRIBUTION_URL'))

watch(needPublisher, (required) => {
  if (!required) {
    errors.publisherId = ''
  }
})

const getFieldConfig = (field) => {
  return fieldConfigMap[field] || fieldConfigMap.PRICE
}

const resetFilterByField = (item) => {
  const config = getFieldConfig(item.field)
  if (config.type === 'number') {
    item.operator = 'LT'
    item.value = undefined
    item.values = []
    return
  }
  if (config.type === 'brand') {
    item.operator = 'IN'
    item.value = ''
    item.values = []
    return
  }
  item.operator = 'EQ'
  item.value = undefined
  item.values = []
}

const onFilterFieldChange = (item) => {
  resetFilterByField(item)
}

const onBrandSearch = async (keyword) => {
  if (!keyword) {
    brandOptions.value = []
    return
  }
  const list = await api.searchBrand({
    keyword,
    marketplace:CURRENCY_MAPPER[form.countryCode].host,
  })
  brandOptions.value = (list || []).map((item) => ({
    label: item.amazonBrandName || item.name,
    value: item.id,
  }))
}

const addFilter = () => {
  form.filters.push(createDefaultFilter())
}

const removeFilter = (index) => {
  form.filters.splice(index, 1)
}

const selectAllFields = () => {
  form.exportFields = exportFieldOptions.map((item) => item.value)
}

const invertFields = () => {
  const selected = new Set(form.exportFields)
  const inverted = exportFieldOptions
    .map((item) => item.value)
    .filter((value) => !selected.has(value))
  form.exportFields = Array.from(new Set(['asin', ...inverted]))
}

const onCancel = () => {
  router.push('/operator/operation/productsExport')
}

const onSubmit = () => {
  errors.fileName = ''
  errors.publisherId = ''
  errors.exportFields = ''

  if (!form.fileName.trim()) {
    errors.fileName = '请先输入文件名'
    message.warning('请先输入文件名')
    return
  }
  if (needPublisher.value && !form.publisherId) {
    errors.publisherId = '勾选 Attribution URL 时需选择 Publisher 账号'
    message.warning('勾选 Attribution URL 时需选择 Publisher 账号')
    return
  }
  if (form.exportFields.length === 0) {
    errors.exportFields = '请至少选择一个导出字段'
    message.warning('请至少选择一个导出字段')
    return
  }

  const filterConfig = form.filters.map((item) => {
    const config = getFieldConfig(item.field)
    if (config.type === 'brand') {
      return {
        field: item.field,
        operator: item.operator || 'IN',
        value: null,
        values: item.values?.length ? item.values : null,
      }
    }
    return {
      field: item.field,
      operator: item.operator || 'EQ',
      value: item.value !== undefined && item.value !== null ? String(item.value) : null,
      values: null,
    }
  })

  const payload = {
    fileName: form.fileName.trim(),
    countryCode: form.countryCode,
    publisherId: form.publisherId,
    exportFields: form.exportFields,
    filters:filterConfig,
  }
  productsExportApi.createTask(payload).then(res => {
    if(res.success) {
      message.success('创建任务成功')
      router.push('/operator/operation/productsExport')
    } else {
      message.error(res.message)
    }
  })
 
}
</script>

<style scoped lang="less">
.products-export-create {
  width: 100%;
  padding: 16px;
  padding-top: unset;
}

.form-card {
  padding: 20px 24px;
  border: 1px solid #ffffff;
  border-radius: 12px;
  background: #ffffff;
}

.section-title {
  margin: 10px 0 18px;
  padding-left: 8px;
  border-left: 3px solid #1f1b2d;
  font-weight: 600;
  font-size: 16px;
  color: #1f1b2d;
}

.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.label {
  width: 150px;
  padding-top: 5px;
  font-weight: 500;
  color: #1f1b2d;
}

.required::before {
  content: '*';
  margin-right: 4px;
  color: #eb4e3d;
}

.file-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.count {
  color: #eb4e3d;
  font-size: 12px;
}

.suffix {
  color: #1f1b2d;
}

.field-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tip {
  color: var(--dark-3);
  font-size: 12px;
}

.error-text {
  margin-top: 4px;
  color: #eb4e3d;
  font-size: 12px;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.filter-tip {
  margin-bottom: 8px;
  color: var(--dark-3);
  font-size: 12px;
}

.add-link {
  display: inline-block;
  margin-bottom: 18px;
  color: #7653da;
}

.remove-link {
  color: #eb4e3d;
}

.checkbox-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.field-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(120px, 1fr));
  row-gap: 14px;
}

.field-item {
  color: #1f1b2d;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}
</style>